import { useEasyPaisaStore } from '~/stores/easypaisa';
import { getUserAuthCodeResult } from '~/utils/easypaisa-auth';
import { createPaymentResult } from '~/utils/easypaisa-payment';

export async function registerEasypaisaCallbacks() {
	const store = useEasyPaisaStore();
	if (!store.isEasypaisaMiniapp) return;

	(window as any).getUserAuthCodeResult = getUserAuthCodeResult;

	// Payment result callback - complete order for EasyPaisa payment
	(window as any).createPaymentResult = createPaymentResult;
}
